import { useState } from "react";

const GALLERY_IMAGES = [
  {
    src: "https://images.unsplash.com/photo-1773578978637-c9771e7a9913?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBoYXJkd29vZCUyMGZsb29yaW5nJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzc2MzQxNzQ5fDA&ixlib=rb-4.1.0&q=85",
    title: "Engineered Timber - Living Room",
    category: "Timber"
  },
  {
    src: "https://images.unsplash.com/photo-1771371097061-3befd4b71b59?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBoYXJkd29vZCUyMGZsb29yaW5nJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzc2MzQxNzQ5fDA&ixlib=rb-4.1.0&q=85",
    title: "Hardwood Flooring - Open Plan",
    category: "Timber"
  },
  {
    src: "https://images.unsplash.com/photo-1765767056681-9583b29007cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA7MDR8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBkYXJrJTIwaW50ZXJpb3IlMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc3NjM0MTc0OXww&ixlib=rb-4.1.0&q=85",
    title: "Luxury Vinyl Plank - Modern Interior",
    category: "Vinyl"
  },
  {
    src: "https://images.unsplash.com/photo-1594873676631-e7219ce8eac7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB2aW55bCUyMGxhbWluYXRlJTIwZmxvb3JpbmclMjBpbnRlcmlvcnxlbnwwfHx8fDE3NzYzNDE4NzB8MA&ixlib=rb-4.1.0&q=85",
    title: "Hybrid Flooring - Kitchen & Dining",
    category: "Hybrid"
  },
  {
    src: "https://images.unsplash.com/photo-1615651586009-30e2501c2321?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBoYXJkd29vZCUyMGZsb29yaW5nJTIwaW5zdGFsbGF0aW9ufGVufDB8fHx8MTc3NjM0MTg3MHww&ixlib=rb-4.1.0&q=85",
    title: "Classic Timber - Master Bedroom",
    category: "Timber"
  },
  {
    src: "https://images.unsplash.com/photo-1765766601592-ac2936aa87e0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA7MDR8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBkYXJrJTIwaW50ZXJpb3IlMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc3NjM0MTc0OXww&ixlib=rb-4.1.0&q=85",
    title: "Laminate - Contemporary Office",
    category: "Laminate"
  },
  {
    src: "https://images.unsplash.com/photo-1560185008-b033106af5c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBoYXJkd29vZCUyMGZsb29yaW5nJTIwaW5zdGFsbGF0aW9ufGVufDB8fHx8MTc3NjM0MTg3MHww&ixlib=rb-4.1.0&q=85",
    title: "Polished Hardwood - Dining Area",
    category: "Timber"
  },
  {
    src: "https://images.unsplash.com/photo-1579967753562-a159d3c95125?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjB2aW55bCUyMGxhbWluYXRlJTIwZmxvb3JpbmclMjBpbnRlcmlvcnxlbnwwfHx8fDE3NzYzNDE4NzB8MA&ixlib=rb-4.1.0&q=85",
    title: "Vinyl Plank - Home Office",
    category: "Vinyl"
  },
];

const CATEGORIES = ["All", "Timber", "Hybrid", "Vinyl", "Laminate"];

export default function GalleryPage() {
  const [activeFilter, setActiveFilter] = useState("All");

  const filtered = activeFilter === "All"
    ? GALLERY_IMAGES
    : GALLERY_IMAGES.filter(img => img.category === activeFilter);

  return (
    <main data-testid="gallery-page" className="pt-20">
      <section className="py-20 md:py-28 bg-[#0a0a0a] border-b border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <p className="font-sans uppercase text-xs tracking-[0.2em] text-[#D4AF37] mb-4">Our Work</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-white mb-4">
            Project Gallery
          </h1>
          <p className="font-sans text-base text-[#A3A3A3] max-w-2xl mx-auto">
            Browse our portfolio of completed flooring projects. Every installation showcases our commitment to quality and precision.
          </p>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-[#050505]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          {/* Filters */}
          <div className="flex flex-wrap items-center justify-center gap-3 mb-12" data-testid="gallery-filters">
            {CATEGORIES.map((cat) => (
              <button
                key={cat}
                data-testid={`filter-${cat.toLowerCase()}`}
                onClick={() => setActiveFilter(cat)}
                className={`px-6 py-2 text-sm font-sans uppercase tracking-wider transition-all duration-200 ${
                  activeFilter === cat
                    ? "bg-[#D4AF37] text-black font-semibold"
                    : "border border-white/10 text-[#A3A3A3] hover:border-[#D4AF37]/40 hover:text-white"
                }`}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((img, i) => (
              <div
                key={i}
                data-testid={`gallery-item-${i}`}
                className="group relative overflow-hidden bg-[#121212] border border-white/5 transition-all duration-300 hover:border-[#D4AF37]/30"
              >
                <div className="relative h-72 overflow-hidden">
                  <img
                    src={img.src}
                    alt={img.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/90 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
                    <p className="font-serif text-white text-base">{img.title}</p>
                    <p className="font-sans text-[#D4AF37] text-xs uppercase tracking-wider mt-1">{img.category}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
